import { getField, updateField } from 'vuex-map-fields';
import { client } from "@/api/client";
import { isValidAccountCS, isValidAccountGI } from "@/modules/accounts/domain/Account.js";
import { VueFeatureRepository } from "@/modules/shared/infra/FeatureRepository.js"

export const SET_CURRENT_FILTERS = "SET_CURRENT_FILTERS";
export const CLEAN_FILTERS = "CLEAN_FILTERS";
export const CLEAN_ALL_FILTERS = "CLEAN_ALL_FILTERS";
export const IDENTITY_KEY_CHOICES = "IDENTITY_KEY_CHOICES";
export const SET_ACCOUNTS = "SET_ACCOUNTS";

const state = () => ({
    actualScreen: '',
    selectedIvaCheck: undefined,
    inputLabels: {
        'type': 'Tipo',
        'cif': 'CIF',
        'name': 'Nombre',
        'alias': 'Nombre Comercial',
        'first_name': 'Nombre',
        'first_surname': 'Primer Apellido',
        'second_surname': 'Segundo Apellido',
        'dire': 'DIRe',
        'accounting_office': 'Oficina Contable',
        'management_body': 'Órgano de Gestión',
        'processing_unit': 'Unidad Tramitadora',
        'proposing_body': 'Órgano Proponente',
        'reference': 'Referencia',
        'expens_accounts': 'Cuentas de gastos',
        'expens_account_bien_inversion': 'Cuenta de gastos en bienes de inversión',
        'ref_expens_accounts': 'Cuentas de gastos con referencia',
        'ref_income_accounts': 'Cuentas de ingresos con referencia',
        'credit_account': 'Cuenta de proveedor',
        'income_accounts': 'Cuentas de ingresos',
        'debit_account': 'Cuenta de Cliente',
        'retention_type': 'Tipo de Retención',
        'fiscal_location': 'Localización Fiscal',
        'percent': 'Porcentaje',
        'inversion_sujeto_pasivo_iva': 'Inversión sujeto pasivo IVA',
        'inversion_sujeto_pasivo_igic': 'Inversión sujeto pasivo IGIC',
        'iva_igic_no_deducible': 'IVA/IGIC no deducible',
        'gasto_iva_parcial': 'Gasto+IVA deducible parcialmente',
        'iva_parcial': 'IVA deducible parcialmente',
        'gasto_iva_percent': 'Porcentaje',
        'intracomunitario': 'Intracomunitario',
        'intracomunitario_type': 'Tipo',
        'extracomunitario': 'Extracomunitario',
        'no_sujeta': 'No sujeta',
        'dry_0_percent': 'Tipo 0%',
        'apl_re_0': 'Aplica recargo 0%',
        'bien_inversion': 'Bienes de inversión',
        'address': 'Dirección',
        'zip_code': 'CP',
        'city': 'Ciudad',
        'province': 'Provincia',
        'country': 'País',
        'email': 'Email',
        'website': 'Website',
        'phone': 'Teléfono',
        'notes': 'Notas',
        'review': 'Revisar antes de contabilizar',
        'payment_account': 'Cuenta de Pago',
        'automatic_payment_account': 'Pago automático',
        'payment_method': 'Método de pago',
        'charge_account': 'Cuenta de Cobro',
        'automatic_charge_account': 'Cobro automático',
        'cut_inv_num': 'Recortar número de factura',
        'suplido_account': 'Cuenta Suplidos',
        'num_chars_inv_num': 'Número de caracteres a mantener',
        'chars_to_exclude': 'Caracteres a excluir al recortar',
        'identity_key': 'Clave identificación',
        'auto_fill_due_date': 'Autorrellenar fecha de vencimiento',
        'prorate': 'Prorrata',
        'default_actividad': 'Actividad por Defecto',
        'default_project': 'Proyecto por Defecto', 
        'default_channel': 'Canal por Defecto',
        'building_code': 'Código de inmueble',
        'decimal_separator':'Separador decimal (en ambigüedad)',
        'have_serie': '¿Tiene serie?',
        'series': 'Series',
        'max_price':'Total factura máximo esperado',
        'min_price':'Total factura mínimo esperado',
        'cadastral_reference':'Referencia catastral',
        'criterio_de_caja': 'Criterio de Caja',
        'description_sii': 'Descripción SII',
        'fixed_value': 'Valor Fijo',
        'exc_expense_account': 'Cuenta de gastos para IVA no deducible',
        'iva_no_deducible_account':'Cuenta iva no deducible',
        'gasto_no_deducible_account':'Cuenta gastos no deducible',
        'is_comerciante_minorista': 'Comerciante Minorista',
        'is_comerciante_minorista_percent': 'Porcentaje',
        'retention_professional_account': 'Cuenta Retención Profesionales',
        'retention_rental_account': 'Cuenta Retención Alquileres',
        'retention_customer_account': 'Cuenta Retención',
        'register_iva_igic_0': 'Registrar en libro de facturas',
        'ignore_cif_validation': 'Ignorar Validación CIF',
        'expens_income_type': 'Tipo de Gasto/Ingreso',
    },
    screenValues: {
        supplierScreenValues: {
            'type': '',
            'cif': '',
            'name': '',
            'alias': '',
            'first_name': '',
            'first_surname': '',
            'second_surname': '',
            'dire': '',
            'accounting_office': '',
            'management_body': '',
            'processing_unit': '',
            'proposing_body': '',
            'reference': '',
            'expens_accounts': [],
            'expens_account_bien_inversion': '',
            'ref_expens_accounts' : [],
            'credit_account': '',
            'retention_type': '',
            'inversion_sujeto_pasivo_iva_percent': '',
            'inversion_sujeto_pasivo_iva': false,
            'inversion_sujeto_pasivo_igic_percent': '',
            'inversion_sujeto_pasivo_igic': false,
            'iva_igic_no_deducible': false,
            'gasto_iva_parcial': false,
            'iva_parcial': false,
            'gasto_iva_percent': 50,
            'intracomunitario_percent': '',
            'intracomunitario_type': '',
            'intracomunitario': false,
            'importaciones_percent': '',
            'extracomunitario': false,
            'no_sujeta': false,
            'dry_0_percent': false,
            'bien_inversion': false,
            'retention_type_choices': [],
            'address': '',
            'zip_code': '',
            'city': '',
            'province': '',
            'country': '',
            'email': '',
            'website': '',
            'phone': '',
            'notes': '',
            'review': '',
            'payment_account': '',
            'payment_method':'',
            'automatic_payment_account': '',
            'automatic_payment_account_choices': [],
            'charge_account': '',
            'automatic_charge_account': '',
            'building_code':'',
            'decimal_separator':null,
            'have_serie': false,
            'series': [],
            'max_price':null,
            'min_price':null,
            'suplido_account':'',
            'cadastral_reference':'',
            'refs_no_sujeta':[],
            'criterio_de_caja': false,
            'is_comerciante_minorista': false,
            'is_comerciante_minorista_percent': '',
            'description_sii': 'descr_factura',
            'fixed_value': '',
            'exc_expense_account': '',
            'iva_no_deducible_account':'',
            'gasto_no_deducible_account':'',
            'default_actividad': '', 
            'default_project': '', 
            'default_channel': null,
            'retention_professional_account': '',
            'retention_rental_account': '',
            'register_iva_igic_0': false,
            'ignore_cif_validation': false,
            'default_expens_income_type': null,
            'data': {},
        },
        customerScreenValues: {
            'type': '',
            'first_name': '',
            'first_surname': '',
            'second_surname': '',
            'dire': '',
            'accounting_office': '',
            'management_body': '',
            'processing_unit': '',
            'proposing_body': '',
            // 'cif': '',
            // 'name': '',
            'reference': '',
            'income_accounts': '',
            'ref_income_accounts' : [],
            'retention_type_choices': [],
            // 'debit_account': '',
            'inversion_sujeto_pasivo_iva': false,
            'inversion_sujeto_pasivo_igic': false,
            'iva_igic_no_deducible': false,
            'intracomunitario': false,
            'extracomunitario': false,
            'no_sujeta': false,
            'dry_0_percent':false,
            'apl_re_0': false,
            'address': '',
            'zip_code': '',
            'city': '',
            'province': '',
            'country': '',
            // 'email': '',
            // 'website': '',
            // 'phone': '',
            'notes': '',
            'payment_method':'',
            // 'review': '',
            'max_price':null,
            'refs_no_sujeta':[],
            'min_price': null,
            'description_sii': 'descr_factura',
            'fixed_value': '',
            'default_actividad': '', 
            'default_project': '', 
            'default_channel': null,
            'automatic_charge_account': '',
            'charge_account': '',
            'retention_customer_account': '',
            'register_iva_igic_0': false,
            'ignore_cif_validation': false,
            'default_expens_income_type': null,
            'data': {},
        }
    },
    screenErrors: {
        supplierScreenValues: {},
        customerScreenValues: {}
    },

    currentFilters: {
        supplierListValues: "",
        customerListValues: ""
    },
    filtersData: {
        supplierListValues: {
            supplier__name__icontains: {
                'name': 'supplier__name__icontains', 
                'label': 'Nombre de proveedor',
                'value': ''
            },
            supplier__nif__icontains: {
                'name': 'supplier__nif__icontains', 
                'label': 'CIF de proveedor',
                'value': ''
            },
            expens_account__icontains: {
                'name': 'expens_account__icontains', 
                'label': 'Cuenta de Gastos',
                'value': ''
            },
            credit_account__icontains: {
                'name': 'credit_account__icontains', 
                'label': 'Cuenta de Proveedor',
                'value': ''
            }
        },
        customerListValues: {
            customer__name__icontains: {
                'name': 'customer__name__icontains', 
                'label': 'Nombre de cliente',
                'value': ''
            },
            customer__nif__icontains: {
                'name': 'customer__nif__icontains', 
                'label': 'CIF de cliente',
                'value': ''
            },
            income_account__icontains: {
                'name': 'income_account__icontains', 
                'label': 'Cuenta de Ingresos',
                'value': ''
            },
            debit_account__icontains: {
                'name': 'debit_account__icontains', 
                'label': 'Cuenta',
                'value': ''
            },
            einvoice_customer: {
                'name': 'einvoice_customer',
                'label': 'Cliente Factura electrónica',
                'value': false
            }
        }
    },
    actions: {
        supplierListValues: [
            { 'id': 'export', 'name': 'Exportar Proveedores en excel', 'group': 'action', 'excel': true},
            { 'id': 'delete', 'name': 'Borrar Proveedores', 'group': 'action', 'excel': false},
            { 'id': 'massive_change', 'name': 'Cambios Masivos', 'group': 'action', 'excel': false, "permission": "feature_not_create_thirds_and_masters"},
        ],
        customerListValues: [
            { 'id': 'export', 'name': 'Exportar Clientes en excel', 'group': 'action', 'excel': true},
            { 'id': 'delete', 'name': 'Borrar Clientes', 'group': 'action', 'excel': false},
            { 'id': 'massive_change', 'name': 'Cambios Masivos', 'group': 'action', 'excel': false, "permission": "feature_not_create_thirds_and_masters"},
        ],
    },
    identity_keys: [],
    action: undefined,
    accounts: [],
});

const getters = {
    getField,
    getScreenValuesField(state) {
        return getField(state[state.actualScreen])
    },
    getExtracomunitarioLabel: (state) => {
        if (state.actualScreen == 'supplierScreenValues')
            return 'Extracomunitario (Importaciones)'
        else
            return 'Extracomunitario (Exportaciones)'
    },
}
const mutations = {
    updateField,
    updateScreenValues(state, field) {
        state.screenValues[state.actualScreen] = field.value;
    },
    updateScreenValues2(state, field) {
        state.screenValues[state.actualScreen] = field;
        //Get Iva check radiobuttons
        if (state.actualScreen == 'supplierScreenValues') {
            if (state.screenValues[state.actualScreen].iva_igic_no_deducible) {
                state.selectedIvaCheck = 'iva_igic_no_deducible';
            }
            else if (state.screenValues[state.actualScreen].gasto_iva_parcial) {
                state.selectedIvaCheck = 'gasto_iva_parcial';
            }
            else if (state.screenValues[state.actualScreen].iva_parcial) {
                state.selectedIvaCheck = 'iva_parcial';
            }
            else if (state.screenValues[state.actualScreen].prorate) {
                state.selectedIvaCheck = 'prorate';
            }
        }
    },
    updateScreenErrors(state, field) {
        state.screenErrors[state.actualScreen] = field;
    },
    updateScreenValuesFields(state, {fieldname, value}) {
        state.screenValues[state.actualScreen][fieldname] = value;
    },
    updateScreenValuesArray(state, {fieldname, value}) {
        
        state.screenValues[state.actualScreen][fieldname] = []
        for(let i in value){
            state.screenValues[state.actualScreen][fieldname][i] = value[i]
        }
    },
    [SET_CURRENT_FILTERS](state, filts) {
        state.currentFilters[state.actualScreen] = filts;
    },
    [CLEAN_FILTERS](state) {
        for (let i in state.filtersData[state.actualScreen]) {
            state.filtersData[state.actualScreen][i].value = '';
        }
    },
    [CLEAN_ALL_FILTERS](state) {
        for (let screen in state.filtersData) {
            state.currentFilters[screen] = '';
            for (let i in state.filtersData[screen]) {
                state.filtersData[screen][i].value = '';
            }
        }
    },
    [IDENTITY_KEY_CHOICES](state, choices) {
        state.identity_keys = choices;
    },
    [SET_ACCOUNTS](state, accounts) {
        state.accounts = accounts;
    },
}

const getData = ({ commit, state }, { id, url, nif, name }) => {
    return new Promise((resolve, reject)=> {
        commit('updateScreenValues2', {});
        if (id) {
            client.get(url + id + '/').then(response => {  
                response.data['refs_no_sujeta'] = response.data['grefs_no_sujeta']  
                delete response.data['grefs_no_sujeta']           
                commit('updateScreenValues2', response.data);
                resolve();
            }).catch(err=>{
                console.log(err)
                reject();
            });
        } else {
            if (state.actualScreen == 'supplierScreenValues') {
                commit('updateScreenValues2', {
                    'type': '',
                    'cif': nif, 
                    'name': name,
                    'alias': '',
                    'first_name': '',
                    'first_surname': '',
                    'second_surname': '',
                    'dire': '',
                    'accounting_office': '',
                    'management_body': '',
                    'processing_unit': '',
                    'proposing_body': '',
                    'address': '',
                    'zip_code': '',
                    'city': '',
                    'province': '',
                    'country': '',
                    'email': '',
                    'phone': '',
                    'website': '',                    
                    'reference': '',
                    'credit_account': '',
                    'ref_expens_accounts' : [],
                    'inversion_sujeto_pasivo_iva_percent': 'vat_21',
                    'inversion_sujeto_pasivo_iva': false,
                    'inversion_sujeto_pasivo_igic_percent': 'igic_7',
                    'inversion_sujeto_pasivo_igic': false,
                    'iva_igic_no_deducible': false,
                    'gasto_iva_parcial': false,
                    'iva_parcial': false,
                    'gasto_iva_percent': 50,
                    'intracomunitario_percent': 'vat_21',
                    'intracomunitario_type': 'bienes',
                    'intracomunitario': false,
                    'importaciones_percent': 'vat_21',
                    'extracomunitario': false,
                    'no_sujeta': false,
                    'dry_0_percent':false,
                    'bien_inversion': false,
                    'building_code':'',
                    'payment_method':'',
                    'decimal_separator':null,
                    'have_serie': false,
                    'series': [],
                    'max_price':null,
                    'min_price':null,
                    'suplido_account':'',
                    'refs_no_sujeta':[],
                    'criterio_de_caja': false,
                    'is_comerciante_minorista': false,
                    'is_comerciante_minorista_percent': 'igic_7',
                    'description_sii': 'descr_factura',
                    'fixed_value': '',
                    'retention_professional_account': '',
                    'retention_rental_account': '',
                    'register_iva_igic_0': false,
                    'ignore_cif_validation': false,
                    'automatic_payment_account': 'na',
                });
            } else if (state.actualScreen == 'customerScreenValues') {
                commit('updateScreenValues2', {
                    'type': '',
                    'cif': nif, 
                    'name': name,
                    'alias': '',
                    'first_name': '',
                    'first_surname': '',
                    'second_surname': '',
                    'dire': '',
                    'accounting_office': '',
                    'management_body': '',
                    'processing_unit': '',
                    'proposing_body': '',
                    'address': '',
                    'zip_code': '',
                    'city': '',
                    'province': '',
                    'country': '',
                    'email': '',
                    'phone': '',
                    'website': '',
                    'reference': '',
                    'ref_income_accounts' : [],
                    'inversion_sujeto_pasivo_iva': false,
                    'inversion_sujeto_pasivo_igic': false,
                    'intracomunitario': false,
                    'intracomunitario_type': 'bienes',
                    'extracomunitario': false,
                    'no_sujeta': false,
                    'dry_0_percent':false,
                    'apl_re_0': false,
                    'payment_method':'',
                    'max_price':null,
                    'min_price':null,
                    'refs_no_sujeta':[],
                    'suplido_account': '',
                    'description_sii': 'descr_factura',
                    'fixed_value': '',
                    'ignore_cif_validation': false,
                    'automatic_charge_account': 'na',
                });
            }
            resolve();
        }
    });
}
const updateScreenValuesArray = ({state,commit},{field,value}) => {
    commit('updateScreenValuesArray', {'fieldname': field, 'value': value})
}

const getFirstError = (errors) => {
    Object.keys(errors).forEach((e)=>{
        errors[e]=errors[e][0]
    });
    return errors
}

const areAccountsMaxLengthError = ({ state, rootGetters }, { currentCompany, userData }) => {
    let accounts_errors = {}
    accounts_errors['credit_account_error'] = false
    accounts_errors['debit_account_error'] = false
    accounts_errors['expens_accounts_error'] = false
    accounts_errors['ref_expens_accounts_error'] = []
    accounts_errors['income_accounts_error'] = false
    accounts_errors['ref_income_accounts_error'] = []
    accounts_errors['expens_account_bien_inversion_error'] = false
    accounts_errors['exc_expense_account_error'] = false
    accounts_errors['iva_no_deducible_account_error'] = false
    accounts_errors['gasto_no_deducible_account_error'] = false
    let feature_repo = new VueFeatureRepository(rootGetters.got_feature);
    
    for (let i in state.screenValues[state.actualScreen]['ref_expens_accounts']) {
        accounts_errors['ref_expens_accounts_error'].push(false);
    }
    for (let i in state.screenValues[state.actualScreen]['ref_income_accounts']) {
        accounts_errors['ref_income_accounts_error'].push(false);
    }

    for(let accounts of ['expens_accounts','income_accounts']){
        if (state.screenValues[state.actualScreen][accounts] && state.screenValues[state.actualScreen][accounts].length && state.screenValues[state.actualScreen][accounts][0] != '') {
            for (let i in state.screenValues[state.actualScreen][accounts]) {
                accounts_errors[accounts+'_error'] = !isValidAccountGI(state.screenValues[state.actualScreen][accounts][i], currentCompany, userData, feature_repo)
            }
        }
    }
    for(let account of ['expens_account_bien_inversion','exc_expense_account','iva_no_deducible_account','gasto_no_deducible_account']){
        if (state.screenValues[state.actualScreen][account] && state.screenValues[state.actualScreen][account].length) {
            accounts_errors[account+'_error'] = !isValidAccountGI(state.screenValues[state.actualScreen][account],currentCompany, userData, feature_repo)
        }
    }
    
    for(let accounts of ['ref_expens_accounts','ref_income_accounts']){
        if (state.screenValues[state.actualScreen][accounts] && state.screenValues[state.actualScreen][accounts].length) {
            for (let i in state.screenValues[state.actualScreen][accounts]) {
                accounts_errors[accounts+'_error'][i] = !isValidAccountGI(state.screenValues[state.actualScreen][accounts][i]['account'],currentCompany, userData, feature_repo);
            }
        }
    }

    for(let account of ['credit_account','debit_account']){
        if (state.screenValues[state.actualScreen][account]) {
            accounts_errors[account+'_error'] = !isValidAccountCS(state.screenValues[state.actualScreen][account],currentCompany, userData);
        }
    }
    return accounts_errors;
}

const areFieldsValidatedPattern = ({ state }, { params }, ) => {

    let err = {}

    if (params['field_pattern']) {
        let patterns = params['field_pattern'];
        let patterns_errors = params['field_pattern_error_messages'];

        for (let key in patterns) {
            if (patterns.hasOwnProperty(key)) {
                let r_key = patterns[key];
                if (state.screenValues[state.actualScreen][key] && !state.screenValues[state.actualScreen][key].match(r_key))
                {
                    if (patterns_errors && patterns_errors[key]){
                        err[key] = state.inputLabels[key] + ": " + patterns_errors[key]
                    } else if (patterns_errors && patterns_errors["default"]){
                        err[key] = state.inputLabels[key] + ": " + patterns_errors["default"]
                    } else {
                        err[key] = state.inputLabels[key] + ": El número de caracteres del campo es incorrecto";
                    }
                }
            }
        }
    }

    return err
}

const isZipcodeCorrect = ({ state }) => {
    let error = false;
    if (state.screenValues[state.actualScreen]['zip_code']) {
        const isSpain = !state.screenValues[state.actualScreen]['country'] || state.screenValues[state.actualScreen]['country'] == 'ES'
        if (isSpain && !(state.screenValues[state.actualScreen]['extracomunitario'] || state.screenValues[state.actualScreen]['intracomunitario'])) {            
            if (!/(^\d{5}$)|(^\d{5}-\d{4}$)/.test(state.screenValues[state.actualScreen]['zip_code'])) {
                error = true;
            }
        }
    }
    return error;
}

const getEmptyFieldsError = ({ state, rootGetters }, { currentCompany, action }) => {
    let err = {};
    let keys = [];
    if (state.actualScreen == 'supplierScreenValues') {
        if (action == 'create'){
            keys = ['supplier','supplier_create_only'];
        }
        else{
            keys = ['supplier'];
        }
        
    } else if (state.actualScreen == 'customerScreenValues') {
        if (action == 'create'){
            keys = ['customer','customer_create_only'];
        }
        else{
            keys = ['customer'];
        }
    }

    if (state.screenValues[state.actualScreen]['type'] == '') {
        err['type'] = 'El campo ' + state.inputLabels['type'] + ' es obligatorio, no puede estar en blanco.';
    }

    keys.forEach((key)  => {
        if (key) {    
            if (Boolean(currentCompany['companydb_type']) && Boolean(currentCompany['companydb_type']['required_fields']) && Boolean(currentCompany['companydb_type']['required_fields'][key])) {
                for (let i in currentCompany['companydb_type']['required_fields'][key]) {
                    if (!state.screenValues[state.actualScreen][currentCompany['companydb_type']['required_fields'][key][i]]) {
                        err[currentCompany['companydb_type']['required_fields'][key][i]] = 'El campo ' + state.inputLabels[currentCompany['companydb_type']['required_fields'][key][i]] + ' es obligatorio, no puede estar en blanco.';
                    }
                }
            }
        }
    })

    if (state.screenValues[state.actualScreen]['description_sii'] == 'valor_fijo') {
        if (!state.screenValues[state.actualScreen]['fixed_value']) {
            err['fixed_value'] = 'El campo ' + state.inputLabels['fixed_value'] + ' es obligatorio.';
        }
    }
    if (state.actualScreen == 'supplierScreenValues' && state.screenValues[state.actualScreen]['gasto_iva_parcial']) {
        let gasto_iva_parcial = state.screenValues[state.actualScreen]['gasto_iva_percent'];
        if(!gasto_iva_parcial) {
            err['gasto_iva_percent'] = 'El campo ' + state.inputLabels['gasto_iva_percent'] + ' de ' + state.inputLabels['gasto_iva_parcial'] + ' es obligatorio, no puede estar en blanco.';
        }
        else if(gasto_iva_parcial >= 100 || gasto_iva_parcial <=0) {
            err['gasto_iva_percent'] = 'El campo ' + state.inputLabels['gasto_iva_percent'] + ' de ' + state.inputLabels['gasto_iva_parcial'] + ' debe tener un valor entre 0 y 100, no incluidos.';
        }
    }   
    if (state.actualScreen == 'supplierScreenValues' && state.screenValues[state.actualScreen]['iva_parcial']) {
        let gasto_iva_percent = state.screenValues[state.actualScreen]['gasto_iva_percent'];
        if(!gasto_iva_percent) {
            err['gasto_iva_percent'] = 'El campo ' + state.inputLabels['gasto_iva_percent'] + ' de ' + state.inputLabels['iva_parcial'] + ' es obligatorio, no puede estar en blanco.';
        }
        else if(gasto_iva_percent >= 100 || gasto_iva_percent <=0) {
            err['gasto_iva_percent'] = 'El campo ' + state.inputLabels['gasto_iva_percent'] + ' de ' + state.inputLabels['iva_parcial'] + ' debe tener un valor entre 0 y 100, no incluidos.';
        }
        if(rootGetters.got_feature('feature_exc_expense_account')) {
            let exc_expense_account = state.screenValues[state.actualScreen]['exc_expense_account'];
            if (!exc_expense_account) {
                err['exc_expense_account'] = 'El campo ' + state.inputLabels['exc_expense_account'] + ' es obligatorio, no puede estar en blanco.';
            }
        }
    }   
    return err;
}

const getErrors = ({ state, rootGetters }, { currentCompany, userData, action }) => {
    let err = getEmptyFieldsError({ state, rootGetters }, { currentCompany,action });
    if (!Object.keys(err).length) {
        let length_error = false;
        
        if (state.screenValues[state.actualScreen]['cif'].length > currentCompany['companydb_type']['max_length_cif']) {
            length_error = true;
            err['cif'] = 'Has superado el máximo de caracteres para el campo ' + state.inputLabels['cif'] + ', su máximo es ' + currentCompany['companydb_type']['max_length_cif'] + '.';
        }
        else if (!state.screenValues[state.actualScreen]['ignore_cif_validation'] && state.screenValues[state.actualScreen]['cif'] == currentCompany['cif']) {
            err['cif'] = 'Un tercero no puede tener el mismo cif que la empresa';
        }
        if (state.screenValues[state.actualScreen]['name'].length > currentCompany['companydb_type']['max_length_name']) {
            length_error = true;
            err['name'] = 'Has superado el máximo de caracteres para el campo ' + state.inputLabels['name'] + ', su máximo es ' + currentCompany['companydb_type']['max_length_name'] + '.';
        }
        if (currentCompany['companydb_type']['params']) {
            let params = currentCompany['companydb_type']['params'];
            let errors = areFieldsValidatedPattern({ state }, { params });
            
            if (errors && Object.keys(errors).length > 0){
                length_error = true;
                for (let key in errors) {
                    err[key] = errors[key];
                }
            }
        }

        let accountsError = areAccountsMaxLengthError({ state, rootGetters }, { currentCompany, userData });
        let num_digit_is_max_text = '';
        if (currentCompany['companydb_type']['params'] && currentCompany['companydb_type']['params'].hasOwnProperty('num_digit_is_max_length') && currentCompany['companydb_type']['params']['num_digit_is_max_length']) {
            num_digit_is_max_text = ' un máximo de ';
        }

        if (accountsError['credit_account_error']) {
            length_error = true;
            err['credit_account'] = 'La Cuenta de proveedor debe tener ' + num_digit_is_max_text + currentCompany.num_digits + ' caracteres.';
        } else if (accountsError['debit_account_error']) {
            length_error = true;
            err['debit_account'] = 'La Cuenta de cliente debe tener ' + num_digit_is_max_text + currentCompany.num_digits + ' caracteres.';
        }
        if (accountsError['expens_accounts_error']) {
            length_error = true;
            err['expens_accounts'] = 'Las Cuentas de gastos';
            if (currentCompany['companydb_type']['params'] && currentCompany['companydb_type']['params'].hasOwnProperty('accounts_length')) {
                err['expens_accounts'] += ' para ' + currentCompany['companydb_type']['name'] + ' tienen un máximo de ' + currentCompany['companydb_type']['params']['accounts_length'] + ' caracteres.';
            }
            else if (currentCompany['companydb_type']['params'] && currentCompany['companydb_type']['params'].hasOwnProperty('accounts_max_length')) {
                err['expens_accounts'] += ' para ' + currentCompany['companydb_type']['name'] + ' tienen un máximo de ' + currentCompany['companydb_type']['params']['accounts_max_length'] + ' caracteres.';
            }
            else {
                err['expens_accounts'] += ' deben tener ' + num_digit_is_max_text + currentCompany.num_digits + ' caracteres.';
            }
        } else if (accountsError['income_accounts_error']) {
            length_error = true;
            err['income_accounts'] = 'Las Cuentas de ingresos';
            if (currentCompany['companydb_type']['params'] && currentCompany['companydb_type']['params'].hasOwnProperty('accounts_length')) {
                err['income_accounts'] += ' para ' + currentCompany['companydb_type']['name'] + ' tienen un máximo de ' + currentCompany['companydb_type']['params']['accounts_length'] + ' caracteres.';
            }
            else if (currentCompany['companydb_type']['params'] && currentCompany['companydb_type']['params'].hasOwnProperty('accounts_max_length')) {
                err['income_accounts'] += ' para ' + currentCompany['companydb_type']['name'] + ' tienen un máximo de ' + currentCompany['companydb_type']['params']['accounts_max_length'] + ' caracteres.';
            } 
            else {
                err['income_accounts'] += ' deben tener ' + num_digit_is_max_text + currentCompany.num_digits + ' caracteres.';
            }
        }
        console.log(accountsError)
        if (accountsError['iva_no_deducible_account_error']) {
            length_error = true;
            err['iva_no_deducible_account'] = 'La Cuenta de iva no deducible tiene un numero inadecuado de caracteres.';
        }
        if (accountsError['gasto_no_deducible_account_error']) {
            length_error = true;
            err['gasto_no_deducible_account'] = 'La Cuenta de gasto no deducible tiene un numero inadecuado de caracteres.';
        }
        if (accountsError['ref_expens_accounts_error'].includes(true)) {
            length_error = true;
            err['ref_expens_accounts'] = [];
            for (let i in accountsError['ref_expens_accounts_error']) {
                err['ref_expens_accounts'].push('');
                if (accountsError['ref_expens_accounts_error'][i]){
                    err['ref_expens_accounts'][i] = 'Las Cuentas de gastos extra';
                    if (currentCompany['companydb_type']['params'] && currentCompany['companydb_type']['params'].hasOwnProperty('accounts_length')) {
                        err['ref_expens_accounts'][i] += ' para ' + currentCompany['companydb_type']['name'] + ' tienen un máximo de ' + currentCompany['companydb_type']['params']['accounts_length'] + ' caracteres.';
                    }
                    else if (currentCompany['companydb_type']['params'] && currentCompany['companydb_type']['params'].hasOwnProperty('accounts_max_length')) {
                        err['ref_expens_accounts'] += ' para ' + currentCompany['companydb_type']['name'] + ' tienen un máximo de ' + currentCompany['companydb_type']['params']['accounts_max_length'] + ' caracteres.';
                    } 
                    else {
                        err['ref_expens_accounts'][i] += ' deben tener ' + num_digit_is_max_text + currentCompany.num_digits + ' caracteres.';
                    }
                }
            }
        }
        if (accountsError['ref_income_accounts_error'].includes(true)) {
            length_error = true;
            err['ref_income_accounts'] = [];
            for (let i in accountsError['ref_income_accounts_error']) {
                err['ref_income_accounts'].push('');
                if (accountsError['ref_income_accounts_error'][i]){
                    err['ref_income_accounts'][i] = 'Las Cuentas de ingresos extra';
                    if (currentCompany['companydb_type']['params'] && currentCompany['companydb_type']['params'].hasOwnProperty('accounts_length')) {
                        err['ref_income_accounts'][i] += ' para ' + currentCompany['companydb_type']['name'] + ' tienen un máximo de ' + currentCompany['companydb_type']['params']['accounts_length'] + ' caracteres.';
                    }
                    else if (currentCompany['companydb_type']['params'] && currentCompany['companydb_type']['params'].hasOwnProperty('accounts_max_length')) {
                        err['ref_income_accounts'] += ' para ' + currentCompany['companydb_type']['name'] + ' tienen un máximo de ' + currentCompany['companydb_type']['params']['accounts_max_length'] + ' caracteres.';
                    } 
                    else {
                        err['ref_income_accounts'][i] += ' deben tener ' + num_digit_is_max_text + currentCompany.num_digits + ' caracteres.';
                    }
                }
            }
        }
        if (state.actualScreen == 'supplierScreenValues') {
            if (state.screenValues[state.actualScreen]['credit_account'].toString().includes('.')) {
                length_error = true;
                err['credit_account'] = 'La cuenta de proveedor no debe contener puntos.';
            } else if (currentCompany['companydb_type']['params'] && currentCompany['companydb_type']['params'].hasOwnProperty('invalid_accounts_formats')) {
                const invalid_formats = currentCompany['companydb_type']['params']['invalid_accounts_formats']
                for (const i in invalid_formats) {
                    const regex = new RegExp(invalid_formats[i]);
                    if (regex.test(state.screenValues[state.actualScreen]['credit_account'])) {
                        err['credit_account'] = `La cuenta de proveedor tiene un formato no soportado para ${ currentCompany['companydb_type']['name'] }.`;
                    }
                }
            }
            if (state.screenValues[state.actualScreen]['expens_accounts']) {
                for (let i in state.screenValues[state.actualScreen]['expens_accounts']) {
                    if (state.screenValues[state.actualScreen]['expens_accounts'][i].toString().includes('.')) {
                        length_error = true;
                        err['expens_accounts'] = 'Las cuentas de gastos no deben contener puntos.';
                    }
                }
            }
        } else if (state.actualScreen == 'customerScreenValues') {
            if (state.screenValues[state.actualScreen]['debit_account'].toString().includes('.')) {
                length_error = true;
                err['debit_account'] = 'La cuenta de cliente no debe contener puntos.';
            } else if (currentCompany['companydb_type']['params'] && currentCompany['companydb_type']['params'].hasOwnProperty('invalid_accounts_formats')) {
                const invalid_formats = currentCompany['companydb_type']['params']['invalid_accounts_formats']
                for (const i in invalid_formats) {
                    const regex = new RegExp(invalid_formats[i]);
                    if (regex.test(state.screenValues[state.actualScreen]['debit_account'])) {
                        err['debit_account'] = `La cuenta de proveedor tiene un formato no soportado para ${ currentCompany['companydb_type']['name'] }.`;
                    }
                }
            }
            if (state.screenValues[state.actualScreen]['income_accounts']) {
                for (let i in state.screenValues[state.actualScreen]['income_accounts']) {
                    if (state.screenValues[state.actualScreen]['income_accounts'][i].toString().includes('.')) {
                        length_error = true;
                        err['income_accounts'] = 'Las cuentas de ingresos no deben contener puntos.';
                    }
                }
            }
        }


        if (!((state.actualScreen == 'supplierScreenValues' && (!isNaN(state.screenValues[state.actualScreen]['credit_account']) && !isNaN(parseFloat(state.screenValues[state.actualScreen]['credit_account'])))) || (state.actualScreen == 'customerScreenValues' && (!isNaN(state.screenValues[state.actualScreen]['debit_account']) && !isNaN(parseFloat(state.screenValues[state.actualScreen]['debit_account'])))))) {
            length_error = true;
            let str = "";
            if (state.actualScreen == 'supplierScreenValues') {
                if (state.screenValues[state.actualScreen]['credit_account'].includes('?')) {
                    str = 'Una vez escrito el interrogante debes pulsar enter para autocompletar.';
                } else {
                    str = 'El campo Cuenta de proveedor debe de ser un número.';
                }
                if (!(currentCompany['companydb_type']['params'] && currentCompany['companydb_type']['params'].hasOwnProperty('cif_in_account')))
                    err['credit_account'] = str;
            } else if (state.actualScreen == 'customerScreenValues') {
                if (state.screenValues[state.actualScreen]['debit_account'].includes('?')) {
                    str = 'Una vez escrito el interrogante debes pulsar enter para autocompletar.';
                } else {
                    str = 'El campo Cuenta de cliente debe de ser un número.';
                }
                if (!(currentCompany['companydb_type']['params'] && currentCompany['companydb_type']['params'].hasOwnProperty('cif_in_account')))
                    err['debit_account'] = str;
            }
        }

        if (isZipcodeCorrect({state})) {
            err['zip_code'] = 'El Código Postal introducido no tiene un formato correcto.';
        }

        if (['cut_first', 'cut_last'].includes(state.screenValues[state.actualScreen]['cut_inv_num'])) {
            if (!state.screenValues[state.actualScreen]['num_chars_inv_num']) {
                err['num_chars_inv_num'] = 'El campo Nº de caracteres a mantener es obligatorio si se quiere recortar el número de factura.';
            }
        }
        
        if(state.screenValues[state.actualScreen]['min_price'] && state.screenValues[state.actualScreen]['max_price'] && parseFloat(state.screenValues[state.actualScreen]['max_price']) < parseFloat(state.screenValues[state.actualScreen]['min_price'])){
            err['max_price'] = 'El total de factura màximo debe ser superior al mínimo '+state.screenValues[state.actualScreen]['max_price']+' '+state.screenValues[state.actualScreen]['min_price']
        }
        if(state.screenValues[state.actualScreen]['max_price'] && parseFloat(state.screenValues[state.actualScreen]['max_price']) < 0){
            err['max_price'] = 'El rango de precios debe ser positivo, se aplicará en valor absoluto sobre los abonos'
        }
        if(state.screenValues[state.actualScreen]['min_price'] && parseFloat(state.screenValues[state.actualScreen]['min_price']) < 0){
            err['min_price'] = 'El rango de precios debe ser positivo, se aplicará en valor absoluto sobre los abonos'
        }
        if (accountsError['expens_account_bien_inversion_error']) {
            length_error = true;
            err['expens_account_bien_inversion'] = 'Las Cuentas de gastos de bienes de inversión';
            if (currentCompany['companydb_type']['params'] && currentCompany['companydb_type']['params'].hasOwnProperty('accounts_length')) {
                err['expens_account_bien_inversion'] += ' para ' + currentCompany['companydb_type']['name'] + ' tienen un máximo de ' + currentCompany['companydb_type']['params']['accounts_length'] + ' caracteres.';
            }
            else if (currentCompany['companydb_type']['params'] && currentCompany['companydb_type']['params'].hasOwnProperty('accounts_max_length')) {
                err['expens_account_bien_inversion'] += ' para ' + currentCompany['companydb_type']['name'] + ' tienen un máximo de ' + currentCompany['companydb_type']['params']['accounts_max_length'] + ' caracteres.';
            }
            else {
                err['expens_account_bien_inversion'] += ' deben tener ' + num_digit_is_max_text + currentCompany.num_digits + ' caracteres.';
            }
        }
        if (accountsError['exc_expense_account_error']) {
            length_error = true;
            err['exc_expense_account'] = 'Cuenta de gastos IVA no deducible';
            if (currentCompany['companydb_type']['params'] && currentCompany['companydb_type']['params'].hasOwnProperty('accounts_length')) {
                err['exc_expense_account'] += ' para ' + currentCompany['companydb_type']['name'] + ' debe tener ' + currentCompany['companydb_type']['params']['accounts_length'] + ' caracteres.';
            }
            else if (currentCompany['companydb_type']['params'] && currentCompany['companydb_type']['params'].hasOwnProperty('accounts_max_length')) {
                err['exc_expense_account'] += ' para ' + currentCompany['companydb_type']['name'] + ' tiene un máximo de ' + currentCompany['companydb_type']['params']['accounts_max_length'] + ' caracteres.';
            }
            else {
                err['exc_expense_account'] += ' debe tener ' + num_digit_is_max_text + currentCompany.num_digits + ' caracteres.';
            }
        }
    }
    console.log(err)
    return err;
}

const createObject = ({ commit, state, dispatch, rootGetters }, { url, currentCompany, userData }) => {
    return new Promise((resolve, reject)=> {
        commit('updateScreenErrors', {});
        commit('updateScreenValuesFields', {'fieldname': 'companydb', 'value': currentCompany['id']});
        // if (!Object.keys(err).length) {
        let boolean_fields = ['inversion_sujeto_pasivo_iva', 'inversion_sujeto_pasivo_igic', 'review', 'intracomunitario'];
        boolean_fields.forEach((field)  => {
            if(!state.screenValues[state.actualScreen][field]) {
                commit('updateScreenValuesFields', {'fieldname': field, 'value': false});
            }
        });
        //Set Iva check radiobuttons
        if (state.actualScreen == 'supplierScreenValues') {
            let checks_iva_fields = ['iva_igic_no_deducible', 'gasto_iva_parcial','iva_parcial','prorate']
            checks_iva_fields.forEach((field)  => {
                let value = false;
                if(state.selectedIvaCheck == field) {
                    value = true;
                }
                commit('updateScreenValuesFields', {'fieldname': field, 'value': value});
            });
        }

        // if (state.screenValues[state.actualScreen]['selected_invers']) {
        //     commit('updateScreenValuesFields', {'fieldname': state.screenValues[state.actualScreen]['selected_invers'], 'value': true});
        // }

        if (typeof state.screenValues[state.actualScreen]['income_accounts'] == 'number') {
            commit('updateScreenValuesFields', {'fieldname': 'income_accounts', 'value': state.screenValues[state.actualScreen]['income_accounts'].toString()});
        }

        if (typeof state.screenValues[state.actualScreen]['income_accounts'] == 'string') {
            let income_accounts_split = state.screenValues[state.actualScreen]['income_accounts'].split(',');
            let aux = [];
            income_accounts_split.forEach((acc) => {
                aux.push(acc.trim());
            });
            commit('updateScreenValuesFields', {'fieldname': 'income_accounts', 'value': aux});
        }

        if (typeof state.screenValues[state.actualScreen]['expens_accounts'] == 'number') {
            commit('updateScreenValuesFields', {'fieldname': 'expens_accounts', 'value': state.screenValues[state.actualScreen]['expens_accounts'].toString()});
        }
        if (typeof state.screenValues[state.actualScreen]['expens_accounts'] == 'string') {
            let expens_accounts_split = state.screenValues[state.actualScreen]['expens_accounts'].split(',');
            let aux = [];
            expens_accounts_split.forEach((acc) => {
                aux.push(acc.trim());
            });
            commit('updateScreenValuesFields', {'fieldname': 'expens_accounts', 'value': aux});
        }
        if (typeof state.screenValues[state.actualScreen]['retention_type'] == 'string' && state.screenValues[state.actualScreen]['retention_type'] == "") {
            commit('updateScreenValuesFields', {'fieldname': 'retention_type', 'value': 'no_applies'});
        }
        if (typeof state.screenValues[state.actualScreen]['identity_key'] == 'string' && state.screenValues[state.actualScreen]['identity_key'] == "") {
            commit('updateScreenValuesFields', {'fieldname': 'identity_key', 'value': 'na'});
        }
        if (typeof state.screenValues[state.actualScreen]['min_price'] == 'string' && state.screenValues[state.actualScreen]['min_price'] == "") {
            commit('updateScreenValuesFields', {'fieldname': 'min_price', 'value': null});
        }
        if (typeof state.screenValues[state.actualScreen]['max_price'] == 'string' && state.screenValues[state.actualScreen]['max_price'] == "") {
            commit('updateScreenValuesFields', {'fieldname': 'max_price', 'value': null});
        }  

        let action = 'create'
        let err = getErrors({ state, rootGetters }, { currentCompany, userData, action });  
        if (!Object.keys(err).length) {
            client.post(url, state.screenValues[state.actualScreen]).then(response => {
                commit('updateScreenErrors', {});
                resolve(response);
            }).catch(err=>{
                var response = JSON.parse(err.request.response);
                commit('updateScreenErrors', getFirstError(response));
                reject();
            });
        } else {
            commit('updateScreenErrors', err);
            reject();
        }
    });
}

const updateObject = ({ commit, state, dispatch, rootGetters }, { id, url, currentCompany, userData, applyChangesAllDocs, document_id }) => {
    return new Promise((resolve, reject)=> {
        
        commit('updateScreenErrors', {});
        // if (!Object.keys(err).length) {
        if (Object.keys(state.screenValues[state.actualScreen]).includes('expens_accounts') && typeof(state.screenValues[state.actualScreen]['expens_accounts']) == 'number') {
            commit('updateScreenValuesFields', { 'fieldname': 'expens_accounts', 'value': state.screenValues[state.actualScreen]['expens_accounts'].toString() });
        }
        if (Object.keys(state.screenValues[state.actualScreen]).includes('expens_accounts') && typeof(state.screenValues[state.actualScreen]['expens_accounts']) == 'string') {
            commit('updateScreenValuesFields', { 'fieldname': 'expens_accounts', 'value': state.screenValues[state.actualScreen]['expens_accounts'].split(',') });
        }
        if (Object.keys(state.screenValues[state.actualScreen]).includes('income_accounts') && typeof(state.screenValues[state.actualScreen]['income_accounts']) == 'number') {
            commit('updateScreenValuesFields', { 'fieldname': 'income_accounts', 'value': state.screenValues[state.actualScreen]['income_accounts'].toString() });
        }
        if (Object.keys(state.screenValues[state.actualScreen]).includes('income_accounts') && typeof(state.screenValues[state.actualScreen]['income_accounts']) == 'string') {
            commit('updateScreenValuesFields', { 'fieldname': 'income_accounts', 'value': state.screenValues[state.actualScreen]['income_accounts'].split(',') });
        }
        if (Object.keys(state.screenValues[state.actualScreen]).includes('min_price') && typeof state.screenValues[state.actualScreen]['min_price'] == 'string' && state.screenValues[state.actualScreen]['min_price'] == "") {
            commit('updateScreenValuesFields', {'fieldname': 'min_price', 'value': null});
        }
        if (Object.keys(state.screenValues[state.actualScreen]).includes('max_price') && typeof state.screenValues[state.actualScreen]['max_price'] == 'string' && state.screenValues[state.actualScreen]['max_price'] == "") {
            commit('updateScreenValuesFields', {'fieldname': 'max_price', 'value': null});
        }  
        //podria actualitzar metadata 0s aqui per evitar watch (i faltaria cas canvi d'empresa)
        let boolean_fields = ['inversion_sujeto_pasivo_iva', 'inversion_sujeto_pasivo_igic', 'review', 'intracomunitario', 'extracomunitario', 'no_sujeta', 'bien_inversion', 'dry_0_percent'];
        boolean_fields.forEach((field)  => {
            if(!state.screenValues[state.actualScreen][field]) {
                commit('updateScreenValuesFields', {'fieldname': field, 'value': false});
            }
            else{
                commit('updateScreenValuesFields', {'fieldname': field, 'value': true});
            }
        });

        //Set Iva check radiobuttons
        if (state.actualScreen == 'supplierScreenValues') {
            let checks_iva_fields = ['iva_igic_no_deducible', 'gasto_iva_parcial','iva_parcial','prorate']
            checks_iva_fields.forEach((field)  => {
                let value = false;
                if(state.selectedIvaCheck == field) {
                    value = true;
                }
                commit('updateScreenValuesFields', {'fieldname': field, 'value': value});
            });
        }


        // if(state.screenValues[state.actualScreen]['selected_invers']){
        //     commit('updateScreenValuesFields', {'fieldname': state.screenValues[state.actualScreen]['selected_invers'], 'value': true});
        // }
        let action = 'update'
        let err = getErrors({ state, rootGetters }, { currentCompany, userData, action });

        // Fix para los autocomplete fields que cuando tienen valor null no se envian en el patch
        let autocomplete_fields = ['default_project', 'default_channel', 'default_actividad','default_expens_income_type']
        for (let field of autocomplete_fields) {
            if (field in state.screenValues[state.actualScreen] && state.screenValues[state.actualScreen][field] == null) {
                state.screenValues[state.actualScreen][field] = 'no_value';
            }
        }

        if (!Object.keys(err).length) {
            let params = state.screenValues[state.actualScreen];
            params['apply_changes_all_docs'] = applyChangesAllDocs;
            params['document_id'] = document_id;
            client.patch(url + id + '/', params).then(response => {
                commit('updateScreenErrors', {});
                resolve(response);
            }).catch(err=>{
                var response = JSON.parse(err.request.response);
                commit('updateScreenErrors', getFirstError(response));
                reject();
            });
        } else {
            commit('updateScreenErrors', err);
            reject();
        }
    });
};

const getMassiveErrors = ({ state }, { params, currentCompany }) => {
    let err = {};
    if (params.hasOwnProperty('expens_accounts') && !params['expens_accounts']) {
        err['expens_accounts'] = 'El campo ' + 'Cuentas de gastos' + ' es obligatorio, no puede estar en blanco.';
    }
    if (params.hasOwnProperty('income_accounts') && !params['income_accounts']) {
        err['income_accounts'] = 'El campo ' + 'Cuentas de ingresos' + ' es obligatorio, no puede estar en blanco.';
    }
    if (!Object.keys(err).length) {
        if (currentCompany['companydb_type']['params'] && currentCompany['companydb_type']['params'].hasOwnProperty('accounts_length')) {
            if (params.hasOwnProperty('expens_accounts')) {
                for (let i in params['expens_accounts']) {
                    if (params['expens_accounts'][i].length != currentCompany['companydb_type']['params']['accounts_length']) {
                        err['expens_accounts'] = 'Las Cuentas de gastos tienen un máximo de ' + currentCompany['companydb_type']['params']['accounts_length'] + ' caracteres.';
                    }
                }
            }
            if (params.hasOwnProperty('income_accounts')) {
                for (let i in params['income_accounts']) {
                    if (params['income_accounts'][i].length != currentCompany['companydb_type']['params']['accounts_length']) {
                        err['income_accounts'] = 'Las Cuentas de ingresos tienen un máximo de ' + currentCompany['companydb_type']['params']['accounts_length'] + ' caracteres.';
                    }
                }
            }
            if (params.hasOwnProperty('exc_expense_account')) {
                if (params['exc_expense_account'] && params['exc_expense_account'].length != currentCompany['companydb_type']['params']['accounts_length']) {
                    err['exc_expense_account'] = 'La '+state.inputLabels['exc_expense_account']+' tiene un máximo de ' + currentCompany['companydb_type']['params']['accounts_length'] + ' caracteres.';
                }
            }
        } else {
            if (currentCompany['companydb_type']['params'] && currentCompany['companydb_type']['params'].hasOwnProperty('num_digit_is_max_length') && currentCompany['companydb_type']['params']['num_digit_is_max_length']) {
                if (params.hasOwnProperty('expens_accounts')) {
                    for (let i in params['expens_accounts']) {
                        if (params['expens_accounts'][i].length && params['expens_accounts'][i].length > currentCompany.num_digits) {
                            err['expens_accounts'] = 'Las Cuentas de gastos para esta Empresa debe tener un máximo de ' + currentCompany.num_digits + ' caracteres.';
                        }
                    }
                }
                if (params.hasOwnProperty('income_accounts')) {
                    for (let i in params['income_accounts']) {
                        if (params['income_accounts'][i].length && params['income_accounts'][i].length > currentCompany.num_digits) {
                            err['income_accounts'] = 'Las Cuentas de ingresos para esta Empresa debe tener un máximo de ' + currentCompany.num_digits + ' caracteres.';
                        }
                    }
                }
                if (params.hasOwnProperty('exc_expense_account')) {
                    if (params['exc_expense_account'] && params['exc_expense_account'].length && params['exc_expense_account'].length > currentCompany['companydb_type']['params']['num_digit_is_max_length']) {
                        err['exc_expense_account'] = 'La '+state.inputLabels['exc_expense_account']+' para esta Empresa debe tener un máximo de ' + currentCompany['companydb_type']['params']['num_digit_is_max_length'] + ' caracteres.';
                    }
                }
            } else {
                if (params.hasOwnProperty('expens_accounts')) {
                    for (let i in params['expens_accounts']) {
                        if (params['expens_accounts'][i].length && params['expens_accounts'][i].length != currentCompany.num_digits) {
                            err['expens_accounts'] = 'Las Cuentas de gastos para esta Empresa debe tener ' + currentCompany.num_digits + ' caracteres.';
                        }
                    }
                }
                if (params.hasOwnProperty('income_accounts')) {
                    for (let i in params['income_accounts']) {
                        if (params['income_accounts'][i].length && params['income_accounts'][i].length != currentCompany.num_digits) {
                            err['income_accounts'] = 'Las Cuentas de ingresos para esta Empresa debe tener ' + currentCompany.num_digits + ' caracteres.';
                        }
                    }
                }
                if (params.hasOwnProperty('exc_expense_account')) {
                    if (params['exc_expense_account'] && params['exc_expense_account'].length && params['exc_expense_account'].length != currentCompany.num_digits) {
                        err['exc_expense_account'] = 'La '+state.inputLabels['exc_expense_account']+' para esta Empresa debe tener ' + currentCompany.num_digits + ' caracteres.';
                    }
                }
            }
        }
    }
    if (params.hasOwnProperty('zip_code')) {
        let ignore_zipcode_error = false;
        if ((params.hasOwnProperty('extracomunitario') && params['extracomunitario']) || (params.hasOwnProperty('intracomunitario') && params['intracomunitario'])) {
            ignore_zipcode_error = true;
        }
        if (!/(^\d{5}$)|(^\d{5}-\d{4}$)/.test(params['zip_code']) && !ignore_zipcode_error) {
            err['zip_code'] = 'El Código Postal introducido no tiene un formato correcto.';
        }
    }
    return err;
}

const massiveUpdateObject = ({ commit, state, dispatch }, { url, ids, params, currentCompany }) => {
    return new Promise((resolve, reject)=> {
        commit('updateScreenErrors', {});
        let screen = '';
        if (state.actualScreen == 'customerListValues') {
            screen = 'customerScreenValues';
        }

        if (params.hasOwnProperty('expens_accounts') && typeof(params['expens_accounts']) == 'string') {
            params['expens_accounts'] = params['expens_accounts'].split(',');
        }
        if (params.hasOwnProperty('income_accounts') && typeof(params['income_accounts']) == 'string') {
            params['income_accounts'] = params['income_accounts'].split(',');
        }
        // let boolean_fields = ['inversion_sujeto_pasivo_iva', 'inversion_sujeto_pasivo_igic', 'review', 'iva_igic_no_deducible', 'intracomunitario', 'extracomunitario'];
        // boolean_fields.forEach((field)  => {
        //     if(params[field] && !state.screenValues[screen][field]) {
        //         commit('updateScreenValuesFields', {'fieldname': field, 'value': false});
        //     }
        // });

        let err = getMassiveErrors({ state }, { params, currentCompany });
        if (!Object.keys(err).length) {
            client.patch(url, { 'ids': ids, 'params': params }).then(response => {
                commit('updateScreenErrors', {});
                resolve(response);
            }).catch(err=>{
                console.error(err);
                var response = JSON.parse(err.request.response);
                commit('updateScreenErrors', getFirstError(response));
                reject();
            });
        } else {
            reject(err);
        }
    });
};

const getFilters = ({ commit, state, dispatch }, filts) => {
    // commit(SET_DOCUMENT_OPTIONS_PAGE, 1)
    commit(SET_CURRENT_FILTERS, filts);
    return true;
};
const generateFilters = ({ state, dispatch }) => {
    let filts = "";
    for (let filter in state.filtersData[state.actualScreen]) {
        if (state.filtersData[state.actualScreen][filter].value) {
            filts += "&" + filter + "=" + state.filtersData[state.actualScreen][filter].value;
        }        
    }
    return dispatch("getFilters", filts)
};
const cleanFilters = ({ commit, dispatch }) => {
    commit(CLEAN_FILTERS);
    return dispatch("getFilters", "");
};

const exportCru = ({state}, { url, ids, send_filters, currentCompany, force }) => {
    return new Promise((resolve, reject)=> {
        let params = {};
        if (send_filters) {
            let filts = ''
            for (let filter in state.filtersData[state.actualScreen]) {
                if (state.filtersData[state.actualScreen][filter].value) {
                    filts += "&" + filter + "=" + state.filtersData[state.actualScreen][filter].value;
                }        
            }
            params['filters'] = filts;
            params['cdb'] = currentCompany.id;
        } else {
            params['ids'] = ids;
        }
        if (force) {
            params['force'] = force;
        }
        client.post(url, params).then(resp => {
            resolve(resp);
        }).catch(err => {
            reject(err);
        });
    });
}

const deleteCru = ({}, { url, ids }) => {
    return new Promise((resolve, reject)=> {
        let params = { 'ids': ids };
        client.post(url, params).then(resp => {
            resolve(resp);
        }).catch(err => {
            reject(err);
        });
    });
}

const get_identity_keys = ({ commit }) => {
    return new Promise((resolve, reject)=> {
        client.get('get_identity_key_choices/').then(resp => {
            commit(IDENTITY_KEY_CHOICES, resp.data.identity_keys);
            resolve();
        }).catch(err => {
            console.error(err);
            reject();
        });
    });
};

let getAccountsAbortController = null;

const getAccounts = async ({ commit }, { companydb_id, text }) => {
    // Cancel·lar la petició anterior si encara és activa
    if (getAccountsAbortController) {
        getAccountsAbortController.abort();
    }

    // Crear un nou AbortController per a la nova petició
    getAccountsAbortController = new AbortController();
    const { signal } = getAccountsAbortController;

    try {
        let url = `accounts/?companydb=${companydb_id}`;
        if (text) {
            url += `&text__icontains=${text}`;
        }
        
        const response = await client.get(url, { signal });
        commit(SET_ACCOUNTS, response.data.results);
        return response.data.results;
    } catch (err) {
        if (err.name === 'CanceledError') {
            console.log('Petició cancel·lada');
        } else {
            console.error(`Error fetching accounts: ${err.message}`);
            throw err;
        }
    }
};

const getAccounts2 = ({ commit }, { companydb_id, text }) => {
    return new Promise((resolve, reject)=> {
        let url = 'accounts/?companydb=' + companydb_id;
        if (text) {
            url += '&text__icontains=' + text;
        }
        url += "&limit=50" // Si no viene paginado a 10 y no salen todos resultados
        client.get(url).then(response => {
            resolve(response.data.results);
        }).catch(err => {
            reject(err);
        });
    });
}

const getFacturae = ({ commit }, { companydb_id, text }) => {
    return new Promise((resolve, reject)=> {
        let url = 'facturae/?companydb=' + companydb_id;
        // if (text) {
        //     url += '&text__icontains=' + text;
        // }
        client.get(url).then(response => {
            commit(SET_ACCOUNTS, response.data.results);
            resolve();
        }).catch(err => {
            reject(err);
        });
    });
}


const actions = {
    getData,
    createObject,
    updateObject,
    getErrors,
    getFilters,
    generateFilters,
    cleanFilters,
    exportCru,
    deleteCru,
    massiveUpdateObject,
    get_identity_keys,
    updateScreenValuesArray,
    getAccounts,
    getAccounts2,
    getFacturae,

}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}